export default "__VITE_ASSET__1ba962c4__"